module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.8292/img/gold-tier-icon-bordered.svg"